import React, { memo } from 'react'
import styled from 'styled-components'

import Icon from 'components/Icon'
import { formatBookingNo } from 'utils/formatters'
import { GeneralBookingType } from '../type'

const Outer = styled.button`
  display: block;
  width: 100%;
  height: 72px;
  border: 1px solid #247cdb;
  border-radius: 68px;
  background-color: white;
  color: #247cdb;
  font-size: 24px;
`

type Props = {
  booking: GeneralBookingType
  onClick: (booking: GeneralBookingType) => void
  style?: Object
  className?: string
  children?: React.ReactNode
}

const RowButton: React.FC<Props> = ({ className, style, onClick, booking, children }) => (
  <Outer
    className={`d-flex justify-content-between align-items-center ${className}`}
    style={style}
    onClick={() => onClick(booking)}
  >
    {/* left */}
    <div className="ml-4 font-weight-bold">{children}</div>
    {/* right */}
    <div className="mr-3">
      <span className="mr-4 font-weight-bold">{formatBookingNo(booking?.generalBookingNo)}</span>
      <Icon
        src="/assets/svgs/arrow-right-blue.svg"
        width="12px"
        height="12px"
        style={{ marginTop: -6 }}
      />
    </div>
  </Outer>
)

export default memo(RowButton)
